import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DeleteButton from "../common/DeleteButton";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import ViewDetailsButton from "../common/ViewDetailsButton";
import ThreeDot from "../common/ThreeDot";
import EditButton from "../common/EditButton";
import {
  deleteMainCategory,
  getAllMainCategories,
} from "../../services/category.service";

export default function MainCategories() {
  const { token } = useSelector((state) => state?.auth);

  const [mainCategories, setMainCategories] = useState([]);

  const fetchMainCategories = async () => {
    try {
      const res = await getAllMainCategories(token);
      if (res && res.status >= 200 && res.status < 300) {
        setMainCategories(res?.data?.results);
        console.log("Categories fetched successfully:", res.data);
      } else {
        Swal.fire(
          "Error",
          res?.data?.message || "Failed to fetch categories. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error || "A network or server error occurred. Please try again later.",
        "error"
      );
    }
  };

  useEffect(() => {
    fetchMainCategories();
  }, []);

  const handleDelete = async (categoryName, categoryId) => {
    try {
      const res = await deleteMainCategory(token, categoryId);
      // console.log(res);

      if (res && res.status >= 200 && res.status < 300) {
        Swal.fire(
          "Deleted!",
          `${categoryName} category has been deleted successfully.`,
          "success"
        ).then(() => {
            fetchMainCategories();
        });
      } else {
        Swal.fire(
          "Error",
          res?.data?.detail ||
            "Failed to delete the category. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error during category deletion:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error || "A network or server error occurred. Please try again later.",
        "error"
      );
    }
  };

  return (
    <div className="content-body">
      {/* <!-- row --> */}
      <div className="container-fluid">
        <div className="form-head d-flex mb-3 align-items-start justify-content-between">
          <h2 className="page-title mt-4"></h2>
          <div style={{ zIndex: 2 }}>
            <Link to="/main-categories/add">
              <button className="btn btn-primary px-3 py-2 add-btn sticky-btn">
                Add
                <img
                  className="plus-sign ms-2"
                  src="/assets/images/kidskart/icon/add.png"
                  alt="Add"
                />
              </button>
            </Link>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12 col-xxl-12 col-lg-12 col-sm-12 mt-4">
            <div className="card">
              <div className="card-body p-0">
                {mainCategories && mainCategories.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table order-request2">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Image</th>
                          <th>Main Category</th>
                          <th>Created On</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {mainCategories?.map((item, i) => (
                          <tr key={item.category_id}>
                            <td>{i + 1}</td>
                            <td>
                              <div className="media media2 align-items-center">
                                <img
                                  className="img-fluid"
                                  width="75"
                                  src={item.category_image_url || item.image}
                                  alt={item.category_name}
                                />
                              </div>
                            </td>
                            <td>{item.category_name}</td>
                            <td>
                              {new Date(item.created_at).toLocaleDateString(
                                "en-US",
                                {
                                  month: "short",
                                  day: "numeric",
                                  year: "numeric",
                                }
                              )}
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                <div className="dropdown ms-auto c-pointer">
                                  <ThreeDot />
                                  <div className="dropdown-menu dropdown-menu-end">
                                    <EditButton
                                      to={`/main-categories/update/`}
                                      id={item.category_id}
                                    />

                                    <DeleteButton
                                      name={`${item.category_name} Category`}
                                      onDelete={() =>
                                        handleDelete(
                                          item.category_name,
                                          item.category_id
                                        )
                                      }
                                    />

                                    <ViewDetailsButton
                                      to={`/main-categories/details/`}
                                      id={item.category_id}
                                    />
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))}
                        {mainCategories && mainCategories.length < 3 ? (
                          <tr style={{ height: "205px" }}></tr>
                        ) : null}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="my-5 py-5 text-center fs-4 fw-bold">
                    Please Add Main Category
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
